import { EModelProvider, type IModel as IApiModel } from "../types";

// NOTE: NSAI-4511 — provider-label derivation shared by web + mobile (their
// modelParser copies were byte-identical). Only the LABELS are shared here —
// the matching icon components are React / React Native and stay in each app's
// modelParser (frontend-shared must remain runtime-agnostic).
// NOTE: NSAI-5056 — this used to brand GLM and Kimi by a `startsWith("glm")` /
// `startsWith("kimi")` match on the model NAME, because their rows carried
// provider "openai" and would otherwise have rendered as "Openai". They now
// carry their real vendor, so the label comes from the provider like every
// other model, and the name is no longer consulted at all. Keyed on the enum
// value so a catalog row whose provider predates this table falls through to
// the capitalized slug rather than throwing.
const PROVIDER_LABELS: Partial<Record<EModelProvider, string>> = {
  [EModelProvider.MOONSHOT]: "Kimi",
  [EModelProvider.ZAI]: "GLM",
};

export const getProviderLabel = (
  model: Pick<IApiModel, "provider" | "hostingProvider">,
): string => {
  if (model.hostingProvider.toLowerCase() === "nodeshift") {
    return "On-Prem AI Model";
  }

  const providerLabel = PROVIDER_LABELS[model.provider];
  if (providerLabel) {
    return providerLabel;
  }

  return model.provider.charAt(0).toUpperCase() + model.provider.slice(1);
};
